import { __extends } from "tslib";
import { Plot } from '../../core/plot';
import { deepAssign } from '../../utils';
import { adaptor } from './adaptor';
import './interactions';
var Pie = /** @class */ (function (_super) {
    __extends(Pie, _super);
    function Pie() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** 图表类型 */
        _this.type = 'pie';
        return _this;
    }
    /**
     * 获取 饼图 默认配置项
     */
    Pie.prototype.getDefaultOptions = function () {
        return deepAssign({}, _super.prototype.getDefaultOptions.call(this), {
            legend: {
                position: 'right',
            },
            tooltip: {
                shared: false,
                showTitle: false,
                showMarkers: false,
            },
            label: {
                layout: { type: 'limit-in-plot', cfg: { action: 'ellipsis' } },
            },
            /** 饼图样式, 不影响暗黑主题 */
            pieStyle: {
                stroke: 'white',
                lineWidth: 1,
            },
            /** 饼图中心文本默认样式 */
            statistic: {
                title: {
                    style: { fontWeight: 300, color: '#4B535E', textAlign: 'center', fontSize: '20px', lineHeight: 1 },
                },
                content: {
                    style: {
                        fontWeight: 'bold',
                        color: 'rgba(44,53,66,0.85)',
                        textAlign: 'center',
                        fontSize: '32px',
                        lineHeight: 1,
                    },
                },
            },
            /** 默认关闭 text-annotation 动画 */
            theme: {
                components: {
                    annotation: {
                        text: {
                            animate: false,
                        },
                    },
                },
            },
        });
    };
    /**
     * 获取 饼图 的适配器
     */
    Pie.prototype.getSchemaAdaptor = function () {
        return adaptor;
    };
    return Pie;
}(Plot));
export { Pie };
//# sourceMappingURL=index.js.map